import { Box, Stack, styled, Typography } from '@mui/material';

import AssessmentScore from './AssessmentScore';

const minHeight = 173;

const AssessmentTierWidgetWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.drawer,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(2, 3),
  border: `1px solid ${theme.palette.background.drawer}`,
}));

interface AssessmentScoreWidgetProps {
  value: number;
  size: number;
  direction?: 'row' | 'column';
}

export default function AssessmentScoreWidget({ value, size, direction = 'column' }: AssessmentScoreWidgetProps) {
  return (
    <AssessmentTierWidgetWrapper sx={{ minHeight: direction === 'column' ? minHeight : undefined }}>
      <Stack
        direction={direction}
        alignItems="center"
        justifyContent={direction === 'row' ? 'space-between' : 'center'}
        spacing={2}
      >
        <Typography variant="body2" color="text.muted">
          Access Posture
        </Typography>
        <AssessmentScore value={value} size={size} valueTypographyVariant={direction === 'column' ? 'h5' : undefined} />
      </Stack>
    </AssessmentTierWidgetWrapper>
  );
}
